"use client";

import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Cpu, Microscope, ShieldCheck, Zap } from "lucide-react";
const inspectionSteps = [{
  id: "step-1",
  title: "Integración MS Teams",
  subtitle: "Solución 01",
  description: "Conecte su telefonía empresarial directamente con Microsoft Teams para una colaboración unificada y llamadas externas sin interrupciones.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/ms_teams_integration_interface.png",
  icon: Microscope
}, {
  id: "step-2",
  title: "Agentes de IA",
  subtitle: "Solución 02",
  description: "Automatice la atención al cliente con agentes inteligentes capaces de resolver consultas complejas y agendar citas las 24 horas.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/ai_agents_dashboard.png",
  icon: Cpu
}, {
  id: "step-3",
  title: "Omnicanal PBX-Vtec",
  subtitle: "Solución 03",
  description: "Gestione voz, SMS y WhatsApp desde una única plataforma centralizada, optimizando la productividad de su equipo de soporte.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/omnichannel_pbx_vtec_software.png",
  icon: Zap
}, {
  id: "step-4",
  title: "Encuestas de Valor",
  subtitle: "Solución 04",
  description: "Mida la satisfacción del cliente mediante encuestas automáticas por voz y WhatsApp con reportes detallados en tiempo real.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/voice_surveys_analytics.png",
  icon: ShieldCheck
}];
export default function CapacidadesDelSoftware() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="221996" id="capacidades-del-software" className="bg-background text-foreground py-14 md:py-16 px-6 md:px-12 lg:px-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/5 blur-[120px] rounded-lg pointer-events-none" aria-hidden="true" />

      <div className="max-w-7xl mx-auto relative z-10">
        {}
        <div ref={headerRef} className={`max-w-3xl mb-8 md:mb-10 transition-all duration-1000 ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default font-bold text-4xl md:text-5xl lg:text-6xl tracking-tighter mb-6 text-primary">
            Soluciones Complementarias <br className="hidden md:block" />
            <span className="text-foreground">a Omnicanal.</span>
          </h2>
          <p className="font-default text-lg md:text-xl text-muted-foreground leading-relaxed">
            Nuestra plataforma Omnicanal es el núcleo de su comunicación. Potencie su alcance con estas soluciones complementarias diseñadas para extender las capacidades de su ecosistema digital y maximizar la eficiencia operativa.
          </p>
          <p className="font-default text-lg md:text-xl text-muted-foreground leading-relaxed mt-6">
            La potencia de PBX-Vtec reside en su integración total: el análisis avanzado de llamadas, el marcador predictivo y las encuestas automatizadas trabajan en perfecta sincronía. Esta cohesión permite una gestión omnicanal fluida, donde cada interacción alimenta un ciclo de mejora continua y atención personalizada sin fisuras.
          </p>
        </div>

        {}
        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {inspectionSteps.map((step, i) => {
          const Icon = step.icon;
          return <div key={step.id} data-index={i} className={`transition-all duration-700 delay-[${i * 150}ms] ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                <Card className="h-full rounded-md bg-accent/40 backdrop-blur-md border-border/50 overflow-hidden group hover:border-primary/50 hover:shadow-xl transition-all duration-500">
                  <div className="relative h-48 overflow-hidden bg-muted">
                    <div className="absolute inset-0 bg-background/20 z-10 group-hover:bg-transparent transition-colors duration-500" />
                    <img src={step.image} data-wvc-srcset={`${step.image}-wvc-srcset`} data-wvc-sizes={`${step.image}-wvc-sizes`} alt={step.title} loading="lazy" className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 scale-100 group-hover:scale-105" />
                    <div className="absolute bottom-4 left-4 z-20 bg-background/80 backdrop-blur-sm p-2 border border-border/50 rounded-md">
                      <Icon className="w-5 h-5 text-primary" />
                    </div>
                  </div>
                  <CardHeader className="pt-6 pb-4">
                    <CardDescription className="font-default text-xs uppercase tracking-widest text-secondary mb-2">
                      {step.subtitle}
                    </CardDescription>
                    <CardTitle className="font-default text-xl tracking-tight text-foreground">
                      {step.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="font-default text-sm text-muted-foreground leading-relaxed">
                      {step.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}